import cloneDeep from 'lodash/cloneDeep';

import * as actions from '../redux/constants';

const initialState = {
  isReefLinked: false,
  isReefStatusFetching: false,
  thirdPartyUserId: '',
};

function user(state = initialState, action) {
  const userState = cloneDeep(state);
  switch (action.type) {
    case actions.PATCH_USER_LMS: {
      userState.thirdPartyUserId = action.payload.thirdPartyUserId;
      return userState;
    }

    case actions.UPDATE_REEF_STATUS: {
      userState.isReefLinked = action.payload.isReefLinked;
      userState.reefProfile = action.payload.reefProfile;
      userState.reefCourseName = action.payload.reefCourseName;
      userState.reefCourseId = action.payload.reefCourseId;
      return userState;
    }

    case actions.APP_LOGOUT: {
      return initialState;
    }

    case actions.UPDATE_REEF_STATUS_REQUEST: {
      return {
        ...state,
        isReefStatusFetching: true,
      };
    }

    case actions.UPDATE_REEF_STATUS_SUCCESS: {
      userState.isReefStatusFetching = false;
      return userState;
    }

    case actions.UPDATE_REEF_STATUS_ERROR: {
      return {
        ...state,
        isReefStatusFetching: false,
      };
    }

    default: {
      return userState;
    }
  }
}

user.constants = {
  initialState,
};

export default user;
